import { render, staticRenderFns } from "./ArchitecturalVocational.vue?vue&type=template&id=38eb09c2&scoped=true"
import script from "./ArchitecturalVocational.vue?vue&type=script&lang=js"
export * from "./ArchitecturalVocational.vue?vue&type=script&lang=js"
import style0 from "./ArchitecturalVocational.vue?vue&type=style&index=0&id=38eb09c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb09c2",
  null
  
)

export default component.exports